import React from 'react';
import { FormStack } from '../../components/forms/FormStack';
import { HookedFormField } from '../../components/forms/HookedFormField';
import { HookedInput } from '../../components/forms/HookedInput';

export const ParticipantEmbeddableFormForm = () => {
  return (
    <FormStack>
      <HookedFormField name='name' label='Name'>
        <HookedInput name='name' size='sm' placeholder='Enter a name' noNulls />
      </HookedFormField>
      <HookedFormField name='url' label='URL'>
        <HookedInput name='url' size='sm' placeholder='Enter form URL' noNulls />
      </HookedFormField>
    </FormStack>
  );
};
